// extracted by css-extract-rspack-plugin
var _1 = "filter-VgBAgl";
var _2 = "table-v2N9ZG";
export { _1 as "filter", _2 as "table" }
